import React from 'react';
import Drawing from '@/components/common/Forms/Questions/Drawing';
import { StudentAnswerProps } from '@/components/staffer/Grading/types';
import useGradingStore from '@/components/staffer/Grading/useGradingStore';
import { noAnswerProvided } from '@/components/staffer/Grading/utils';

const DrawingQuestionStudentAnswer = ({ question, questionAnswer }: StudentAnswerProps) => {
  const { currentUser } = useGradingStore();

  if (!questionAnswer) return noAnswerProvided();

  return (
    <div className="tw-w-[220px]">
      <Drawing
        disabled
        answerId={questionAnswer?.id}
        editable={false}
        questionId={question.id}
        userType={currentUser.type}
      />
    </div>
  );
};

export default DrawingQuestionStudentAnswer;
